import { render, staticRenderFns } from "./Resent.vue?vue&type=template&id=24ed26cb&scoped=true&"
import script from "./Resent.vue?vue&type=script&lang=js&"
export * from "./Resent.vue?vue&type=script&lang=js&"
import style0 from "./Resent.vue?vue&type=style&index=0&id=24ed26cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed26cb",
  null
  
)

export default component.exports